import { useEffect, useState } from 'react';
import requets from '../../../api';
import { useAuth } from 'react-oidc-context';

export default function useGraphics({ list }) {
  const auth = useAuth();
    const req = requets(auth.user.access_token);
  
  const [measurement, setMeasurement] = useState({
    energy: [],
    measurement: [],
  });
  const [params, setParams] = useState();

  useEffect(() => {
    function fetchMasurementByList() {
      req.post(`/measurement/bygroup`, list, params).then((response) => {
        if (response.status === 200) {
          setMeasurement(response.data);
        }
      });
    }
    fetchMasurementByList();
  }, [params]);
  return {
    measurement,
    setParams,
  };
}
